module.exports = __webpack_public_path__ + "static/media/351.21b2855d.webp";